export const DEVICE_LIST_TYPE = {
  GATEWAY: 0,
  SENSOR: 2,
  COMPANION: 3,
  CAMERA: 4,
  UNPAIRED: 1,
};
export const DEVICE_TABLE_NAMES = {
  4: "Cameras",
  3: "Companion Devices",
  0: "Gateways",
  2: "Sensors",
  1: "Unpaired Cameras",
};

export const DEVICE_STORAGE_NAMES = {
  3: "companionDevicesList",
  4: "camerasList",
  0: "GatewaysList",
  2: "SensorList",
  6: "TagIdsList",
  1: "UnpairedCamerasList",
  5: "deviceList",
};


export const CCD_MODEL_SMALL ="LEC-2290E";
export const CCD_MODEL_SMALL_LIMIT =15;
export const CCD_MODEL_MEDIUM ="EAI-I730A";
export const CCD_MODEL_MEDIUM_LIMIT =30;



export const IMAGE_FETCHING_CURRENT_STATUS="Fetching latest snapshot from camera.";
export const IMAGE_FETCHING_FAILED_STATUS="Failed to fetch latest snapshot from camera.";

export const DEVICE_INFO_LABELS = {
  SERIAL_NUMBER: "Serial number",
  MAKE: "Make",
  MODEL: "Model",
  COMPANION_VERSION: "Companion version"
};
export const ON_BOARD_TYPE_MANNUAL = "Manual";

export const RESET_CREDS_MODAL = {
  // Titles and Labels
  TITLE: "Reset camera credentials",
  DESCRIPTION: "Specify user name and password that you use to access your cameras.",
  USERNAME_LABEL: "Username",
  PASSWORD_LABEL: "Password",

  // Button Labels
  RESET_BUTTON: "Reset credentials",
  CANCEL_BUTTON: "Cancel",
  REFETCH_BUTTON: "Refetch",

  // Notification Messages
  FETCH_ERROR_TITLE: "Failed to fetch credentials",
  UPDATE_SUCCESS_TYPE: "Access Credentials update",
  UPDATE_SUCCESS_TITLE: "Access credentials updated succefully",
  UPDATE_ERROR_TITLE: "Access credentials not updated",

  // Test IDs
  TEST_ID_RESET_BUTTON: "resetCredsModal_resetCredentialsButton",
  TEST_ID_CANCEL_BUTTON: "resetCredsModal_cancelButton",
  TEST_ID_REFETCH_BUTTON: "resetCredsModal_refetchButton",

  // Notification Priorities
  PRIORITY_SUCCESS: "success",
  PRIORITY_CRITICAL: "critical"
};

export const CCD_VERSION = {
  IN_HOUSE_VERSION : "2.0"
}

export const COMPANION_DEVICE_TABLE_LABELS = {
  STATUS: "Status",
  SOFTWARE: "Software",
  SITE: "Site",
  CLOUD_STORAGE: "Cloud storage",
  CLOUD_STORAGE_TOOLTIP_BODY: "Enabling cloud storage allows videos and images to be to the 5G Video Insights portal for event-related incidents.",
  ETA_PREFIX: "ETA: ",
  UPDATING: "Updating",
  ONLINE: "Online",
  OFFLINE: "Offline",
  NA: "NA",
  NOT_AVAILABLE: "Not Available",
  ENABLED: "Enabled",
  DISABLED: "Disabled"
};
